var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-image",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_2818",
    "data-name": "Ret\\xE2ngulo 2818",
    d: "M2-1H16a3,3,0,0,1,3,3V16a3,3,0,0,1-3,3H2a3,3,0,0,1-3-3V2A3,3,0,0,1,2-1ZM16,17a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2A1,1,0,0,0,1,2V16a1,1,0,0,0,1,1Z",
    transform: "translate(3 3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Elipse_234",
    "data-name": "Elipse 234",
    d: "M1.5-1A2.5,2.5,0,1,1-1,1.5,2.5,2.5,0,0,1,1.5-1Zm0,3A.5.5,0,1,0,1,1.5.5.5,0,0,0,1.5,2Z",
    transform: "translate(7 7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2291",
    "data-name": "Caminho 2291",
    d: "M5,22a1,1,0,0,1-.707-1.707l11-11a1,1,0,0,1,1.414,0l5,5a1,1,0,1,1-1.414,1.414L16,11.414,5.707,21.707A1,1,0,0,1,5,22Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.7a68049a433c2db24b217ded9bd21b7e.svg";
export { ForwardRef as ReactComponent };